<template>
<div class="ui-card">
  <div class="bg-c py-2">
    <h4 class="t-white mb-0 tac">
      {{item.token_symbol}}
    </h4>
  </div>
  <div class="bg-white tac py-3 px-4">

    <div class="pt-2">

      <div>
        {{lg('',{
          en: 'Total Airdrop Amount',
          zh: '总空投数量',
        })}}
        <h5 class="b c fs-22px">
          {{item.total_airdrop | qfw}} {{item.token_symbol}}
        </h5>
      </div>
      <div>
        {{lg('',{
          en: 'Start Block',
          zh: '开始Block',
        })}}
        <h5 class="b c fs-22px">
          {{item.start_block | qfw}}
        </h5>
      </div>
      <div>
        {{lg('',{
          en: 'End Block',
          zh: '结束Block',
        })}}
        <h5 class="b c fs-22px">
          {{item.end_block | qfw}}
        </h5>
      </div>
      <div>
        {{lg('',{
          en: 'Rewards Available',
          zh: '可领取数量',
        })}}
        <h5 class="b c fs-22px">
          {{num_rewards_available | tofixed4 | qfw}} {{item.token_symbol}}
        </h5>
      </div>
      <div>
        {{lg('',{
          en: 'Currently Staked',
          zh: '已质押',
        })}}
        <h5 class="b c fs-22px">
          {{num_currently_staked | tofixed4 | qfw}} iLava
        </h5>
      </div>
      <div>
        {{lg('',{
          en: 'iLava Balance',
          zh: 'iLava数量',
        })}}
        <h5 class="b c fs-22px">
          {{num_iLava_balance | tofixed4 | qfw}} iLava
        </h5>
      </div>

    </div>
  </div>
  <div class="bg-light py-3 px-4">
    <span 
      class="btn btn-primary rounded w-100"
      @click="actionClaim()"
      >
      {{lg('',{
        en: 'Claim Now',
        zh: '立刻领取',
      })}}
    </span>

    <!-- <span 
      class="btn btn-primary rounded w-100 mt-2"
      @click="actionSync()"
      >
      {{lg('',{
        en: 'Sync iLava',
        zh: '同步iLava数量',
      })}}
    </span> -->
  </div>
</div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'airdropCard',
  components: {},
  props: [
    'item',
  ],
  data() {
    return {
      // 可领取数量
      num_rewards_available: '-',
      // 已质押
      num_currently_staked: '-',
      // iLava 数量
      num_iLava_balance: '-',
    }
  },
  computed: {
    address_my(){
      return this.$store.state.web3.account
    },
  },
  watch: {},
  methods: {
    ...mapActions([
      'pendingAirdrop',
      'havaStakeILava',
      'airdrop_getiLavaBalance',
      'claimAirdrop',
      'SyncAirdrop',
    ]),

    async getNumRewardsAvailable(){
      let v = this
      if(!v.address_my){ return }

      let json = Object.assign({},this.item,{address_my: v.$store.state.web3.account})
      let res = await v.pendingAirdrop(json)
      v.num_rewards_available = res
    },
    
    async getNumCurrentlyStaked(){
      let v = this
      if(!v.address_my){ return }

      let json = Object.assign({},this.item,{address_my: v.$store.state.web3.account})
      let res = await v.havaStakeILava(json)
      v.num_currently_staked = res
    },
    
    async getNumILavaBalance(){
      let v = this
      if(!v.address_my){ return }

      let json = Object.assign({},this.item,{address_my: v.$store.state.web3.account})
      let res = await v.airdrop_getiLavaBalance(json)
      v.num_iLava_balance = res
    },

    actionClaim(){
      console.log('actionClaim:')
      let v = this
      let json = Object.assign({},this.item,{address_my: v.$store.state.web3.account})
      v.claimAirdrop(json)

    },
    actionSync(){
      console.log('actionSync:')
      let v = this
      let json = Object.assign({},this.item,{address_my: v.$store.state.web3.account})
      v.SyncAirdrop(json)
    },

    run(){
      this.getNumRewardsAvailable()
      this.getNumCurrentlyStaked()
      this.getNumILavaBalance()
    },
  },
  created() {

    this.run()
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  
</style>